export const updateCartCountDisplay = (count = 0) => {
  if (typeof document === "undefined") {
    return
  }

  const normalizedCount = Number.isFinite(count) && count >= 0 ? count : 0

  document.querySelectorAll("[data-cart-count]").forEach((element) => {
    element.textContent = normalizedCount
  })
}

